import { render, staticRenderFns } from "./AssignPAtoCustomer.vue?vue&type=template&id=0c7de6a1&scoped=true"
import script from "./AssignPAtoCustomer.vue?vue&type=script&lang=js"
export * from "./AssignPAtoCustomer.vue?vue&type=script&lang=js"
import style0 from "./AssignPAtoCustomer.vue?vue&type=style&index=0&id=0c7de6a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7de6a1",
  null
  
)

export default component.exports